import axios from 'axios'
export const GET = async (url, headers) => {
    try {
        let response = await axios.get(url, { headers: headers })

        return response.data
    } catch (error) {
        throw JSON.parse(JSON.stringify(error)).response.data.message
    }
}
export const POST = async (url, data, headers) => {
    try {
        if (headers == null) {
            headers = { 'Content-Type': 'application/json' }
        }
        let response = await axios.post(url, data, { headers: headers })
        return response.data;

    }
    catch (error) {
        console.log("errorhttps",error)
        throw JSON.parse(JSON.stringify(error)).response.data.message;
    }
}
export const PUT = async (url, data, headers) => {
    try {
        if (headers == null) {
            headers = { 'Content-Type': 'application/json' }
        }

        let response = await axios.put(url, data, { headers: headers })
        return response.data;

    } catch (error) {
        console.log("HTTP Put the error is ",JSON.parse(JSON.stringify(error)))
        throw JSON.parse(JSON.stringify(error)).response.data.message
    }
}


export const DELETE = async (url, headers) => {
    try {
        let response = await axios.delete(url, { headers: headers })

        return response
    } catch (error) {
        throw JSON.parse(JSON.stringify(error)).response.data.message
    }
}